module.exports = __webpack_public_path__ + "img/3.4.2.f0722f2c.png";